import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./DevOffer.css";
import back from "../../../../Assets/Images/Services/Web Development/cloud-programming.svg";
import UiUx from "../../../../Assets/Images/Services/Dev For Hire/ux-design.png";
import mob from "../../../../Assets/Images/Services/Dev For Hire/mobile-development.png";
import full from "../../../../Assets/Images/Services/Dev For Hire/full-stack.png";
import front from "../../../../Assets/Images/Services/Dev For Hire/Front-End developer.svg";
import test from "../../../../Assets/Images/Services/Dev For Hire/test.png";
import devOps from "../../../../Assets/Images/Services/Dev For Hire/devOps.png";
import cloud from "../../../../Assets/Images/Services/Dev For Hire/cloud.png";
import database from "../../../../Assets/Images/Services/Dev For Hire/database.png";
import analyst from "../../../../Assets/Images/Services/Dev For Hire/analyst.png";
import { Link } from "react-router-dom";

export const DevOffer = () => {
  return (
    <div id="services" className="offers-container">
      <div className="offers-title-btn text-center">
        <h1 className="offers-title">
          Choose The Right Talent, Not Just A Title
        </h1>
        <p className="offers-desc">
          Hiring works best when job roles are clear and expectations are shared
          upfront. Pick the expertise you need now, and scale or adjust as your
          product changes.
        </p>
        <Link to="/contact-us/hiring-team">
          <button className="offers-btn"> View Hiring Options</button>
        </Link>
      </div>
      <div className="offers-slider">
        <div className="offers os-1 d-flex">
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={back} alt="Backend Developer" className="" />
            <p>Backend Developer</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={front} alt="Front-End Developer" className="" />
            <p>Front-End Developer</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={mob} alt="Mobile App Developer" className="" />
            <p>Mobile App Developer</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={UiUx} alt="UI UX Designer" className="" />
            <p>UI UX Designer</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={full} alt="Full Stack Developer" className="" />
            <p>Full Stack Developer</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={test} alt="QA and Test Engineer" className="" />
            <p>QA and Test Engineer</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={devOps} alt="DevOps Engineer" className="" />
            <p>DevOps Engineer</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={cloud} alt="Cloud Engineer" className="" />
            <p>Cloud Engineer</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={database} alt="Database Engineer" className="" />
            <p>Database Engineer</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={analyst} alt="Business Analyst" className="" />
            <p>Business Analyst</p>
          </div>
        </div>
        <div className="offers os-2 d-flex">
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={back} alt="Backend Developer" className="" />
            <p>Backend Developer</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={UiUx} alt="UI UX Designer" className="" />
            <p>UI UX Designer</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={mob} alt="Mobile App Developer" className="" />
            <p>Mobile App Developer</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={front} alt="Front-End Developer" className="" />
            <p>Front-End Developer</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={full} alt="Full Stack Developer" className="" />
            <p>Full Stack Developer</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={test} alt="QA and Test Engineer" className="" />
            <p>QA and Test Engineer</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={devOps} alt="DevOps Engineer" className="" />
            <p>DevOps Engineer</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={cloud} alt="Cloud Engineer" className="" />
            <p>Cloud Engineer</p>
          </div>
          <div className="db d-flex flex-column justify-content-center alighn-items-start">
            <img src={database} alt="Database Engineer" className="" />
            <p>Database Engineer</p>
          </div>
          <div className="lb d-flex flex-column justify-content-center alighn-items-start">
            <img src={analyst} alt="Business Analyst" className="" />
            <p>Business Analyst</p>
          </div>
        </div>
      </div>
    </div>
  );
};
